// Old navbar, can be removed if new one is launched
$(document).ready(function () {
  $('.nav--resp-menu-toggle').click(function(event){
    event.preventDefault();
    $('.site-wrap').toggleClass('active');
    $('.offscreen-nav').toggleClass('active');
    $('.nav--resp-menu-toggle').toggleClass('active');
  });

  var $window = $(window);
  // On window resize, hide the responsive menu again
  $window.resize( debounce(function(){
    var width = $window.width();
    var $siteWrap = $('.site-wrap')
    //If menu is expanded & viewport is expanded
    if (width > 992 && $siteWrap.hasClass('active')) {
      $siteWrap.removeClass('active');
      $('.offscreen-nav').removeClass('active');
      $('.nav--resp-menu-toggle').removeClass('active');
    }
  }, 250));
});
